import pick from 'lodash/pick'
import AsyncStorage from '@callstack/async-storage'

export const SET_SIGNUP_FORM = 'SET_SIGNUP_FORM'
export const RECEIVED_USER_COOKIE = 'RECEIVED_USER_COOKIE'
export const RECEIVED_COOKIE_USER = 'RECEIVED_COOKIE_USER'

export function setSignUpForm (signUpForm) {
  return dispatch => {
    dispatch(setIntercomCredentials({
      name: `${signUpForm.firstName} ${signUpForm.lastName}`,
      email: signUpForm.email,
      phone: signUpForm.tel
    }))

    dispatch({
      type: SET_SIGNUP_FORM,
      signUpForm
    })
  }
}

export const receivedUserCookie = userCookie => ({
  type: RECEIVED_USER_COOKIE,
  userCookie
})

export const receivedCookieUser = cookieUser => ({
  type: RECEIVED_COOKIE_USER,
  cookieUser
})

export function getUserCookie () {
  return async dispatch => {
    const userCookie = JSON.parse(
      await AsyncStorage.getItem('userCookie'),
      {}
    )

    dispatch(receivedUserCookie(userCookie))
  }
}

export function updateUserCookie (update) {
  return async (dispatch, getState) => {
    const currentCookie = getState().session.userCookie

    const newCookie = Object.assign({}, currentCookie || {}, update)

    AsyncStorage.setItem('userCookie', JSON.stringify(newCookie))

    dispatch(receivedUserCookie(newCookie))
  }
}

export function setScheduleForm (scheduleForm) {
  return (dispatch, getState) => {
    dispatch(setIntercomCredentials({
      name: `${scheduleForm.firstName} ${scheduleForm.lastName}`,
      email: scheduleForm.email,
      phone: scheduleForm.tel
    }))

    if (!getState().session.signUpForm) {
      const signUpValuesFromScheduleForm = pick(
        scheduleForm,
        ['firstName', 'lastName', 'tel', 'email', 'movingDate', 'credit', 'income', 'location']
      )

      AsyncStorage.setItem(
        'signUpForm',
        JSON.stringify(signUpValuesFromScheduleForm)
      )

      dispatch(setSignUpForm(signUpValuesFromScheduleForm))
    }
  }
}

export function setIntercomCredentials (credentials) {
  return dispatch => {
    if (window.intercomSettings.name) return

    window.analytics.track('anonymous_user_identified', {
      name: credentials.name,
      email: credentials.email
    })

    window.Intercom('boot', Object.assign(window.intercomSettings, credentials))
  }
}
